"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fillColour = exports.hexInnerPolygon = exports.hexPolygon = exports.hexDimensions = void 0;
const usStates_1 = require("./usStates");
const colours_module_scss_1 = __importDefault(require("../../styles/colours.module.scss"));
function hexDimensions(i, j, width, stroke, isBigger) {
  const increase = isBigger ? 1.4 : 1;
  const sinSix = Math.sin(Math.PI / 6);
  const doubleApothem = width / usStates_1.statesGrid[0].length * increase;
  const apothem = doubleApothem / 2;
  const radius = apothem / Math.cos(Math.PI / 6);
  const hexDi = radius * 2;
  const halfSideLength = sinSix * radius;
  const offset = i % 2 === 1;
  const offsetX = offset ? apothem * 2 : apothem;
  const x = (offsetX + j * (apothem * 2)) / increase;
  const y = radius + i * (halfSideLength + radius) / increase; // center Y
  return {
    x,
    y,
    radius,
    apothem,
    hexDi
  };
}
exports.hexDimensions = hexDimensions;
function hexPolygon(_ref, width, stroke) {
  let {
    i,
    j
  } = _ref;
  let isBigger = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  const {
    x,
    y,
    radius,
    apothem
  } = hexDimensions(i, j, width, stroke, isBigger);
  const sinSix = Math.sin(Math.PI / 6);
  return [[x, y - radius], [x + apothem, y - sinSix * radius], [x + apothem, y + sinSix * radius], [x, y + radius], [x - apothem, y + sinSix * radius], [x - apothem, y - sinSix * radius] // top left
  ];
}

exports.hexPolygon = hexPolygon;
function hexInnerPolygon(_ref2, width, stroke, offset, isBigger) {
  let {
    i,
    j
  } = _ref2;
  const {
    x,
    y,
    radius,
    apothem
  } = hexDimensions(i, j, width, stroke, isBigger);
  const offsetRad = radius - offset;
  const offsetApothem = apothem - offset;
  const sinSix = Math.sin(Math.PI / 6);
  return [[x, y - offsetRad], [x + offsetApothem, y - sinSix * offsetRad], [x + offsetApothem, y + sinSix * offsetRad], [x, y + offsetRad], [x - offsetApothem, y + sinSix * offsetRad], [x - offsetApothem, y - sinSix * offsetRad]];
}
exports.hexInnerPolygon = hexInnerPolygon;
function fillColour(d, colourFunction, cartogramOptions, isSelected) {
  if (isSelected && cartogramOptions.fillSelected) {
    return cartogramOptions.fillSelected;
  }
  if (cartogramOptions.greyHexes) {
    return colours_module_scss_1.default.chartcolourgreycartogram;
  }
  return colourFunction(d);
}
exports.fillColour = fillColour;